import { DateTime } from "luxon";
import type { ChatSessionSummary } from "../../api/getChatSessions";

interface SessionItemProps {
  session: ChatSessionSummary;
  isDarkMode: boolean;
  selectedSessionId: string | null;
  setSelectedSessionId: (id: string) => void;
}

function SessionItem({
  session,
  isDarkMode,
  selectedSessionId,
  setSelectedSessionId,
}: SessionItemProps) {
  return (
    <button
      type="button"
      onClick={() => setSelectedSessionId(session.uid)}
      className={`w-full mb-2! p-2 md:p-3 rounded-lg! text-left transition-colors min-w-0 ${
        selectedSessionId === session.uid
          ? isDarkMode
            ? "bg-gray-700!"
            : "bg-blue-100!"
          : isDarkMode
            ? "hover:bg-gray-700!"
            : "hover:bg-gray-200!"
      }`}
    >
      <div className="grid grid-cols-[1fr_auto] items-start gap-2 min-w-0">
        <div className="min-w-0 overflow-hidden">
          <h6
            className={`text-sm! font-medium truncate mb-1 ${
              selectedSessionId === session.uid
                ? isDarkMode
                  ? "text-gray-100!"
                  : "text-gray-900!"
                : isDarkMode
                  ? "text-gray-200!"
                  : "text-gray-800!"
            }`}
          >
            {session.name || "Chat Session"}
          </h6>
          <span className={`text-xs text-gray-400!`}>
            {(() => {
              const dateTime = DateTime.fromISO(session.created);
              return dateTime.toLocaleString(DateTime.DATETIME_FULL);
            })()}
          </span>
        </div>
      </div>
    </button>
  );
}

export { SessionItem };
